import Form from 'epn-ui/umd/dist/components/Form';
import InputText from 'epn-ui/umd/dist/components/InputText';
// Helpers
import useI18n from '@i18n';
import { ISupportCreateMessageFormProps } from '../interface';

// Conponents
import CreateMessageActions from '../TemplateActions';

const SupportOtherForm: React.FC<ISupportCreateMessageFormProps> = ({
    question,
    subject,
    loading,
    onClose,
    onSubmit,
}) => {
    const { t } = useI18n('Support');
    const { t: tCommon } = useI18n('Common');

    return (
        <Form
            name="other"
            onFinish={values => {
                const files = [];

                if (
                    values.files &&
                    Array.isArray(values.files.fileList) &&
                    values.files.fileList.length > 0
                ) {
                    values.files.fileList.forEach(item => {
                        files.push({
                            name: item.name,
                            size: item.size,
                            link: item.response,
                        });
                    });
                }

                onSubmit({
                    subject: values.subject,
                    message: values.message,
                    files,
                });
            }}
            initialValues={{
                subject,
                message: question,
            }}
        >
            <Form.Item
                name="subject"
                label={t('Theme')}
                rules={[{ required: true, whitespace: true, message: tCommon('Required field') }]}
            >
                <InputText placeholder={t('Type the subject of the message')} />
            </Form.Item>

            <Form.Item
                name="message"
                rules={[{ required: true, whitespace: true, message: tCommon('Required field') }]}
            >
                <InputText.TextArea
                    placeholder={t('Write a message')}
                    autoSize={{
                        minRows: 4,
                    }}
                />
            </Form.Item>

            <CreateMessageActions loading={loading} onClose={onClose} />
        </Form>
    );
};

export default SupportOtherForm;
